import * as React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as NotFoundImage } from '@icons/images/not-found.svg';

const UserNotResolved: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" flexGrow={1} p={6}>
      <Box alignItems="center" display="flex" justifyContent="center">
        <Typography textAlign="center" variant="subtitle1">
          Person ID not resolved. Please check if &quot;Person ID&quot;
          specified correctly in Zendesk Contact Details tab
        </Typography>
      </Box>
      <Box display="flex" justifyContent="center" mt={6}>
        <NotFoundImage />
      </Box>
    </Box>
  );
};

export default UserNotResolved;
